class Message {

    /**
     * Constructor
     * @param Element messageContainer
     * @param String message
     * @param String type (warning, negative, positive)
     */
    constructor(messageContainer, message, type) {
        if (!messageContainer) return;

        this.messageContainer = messageContainer;
        this.template = messageContainer.querySelector('template');
        this.message = message;
        this.type = type;

        if (!this.template) return;

        this.open();

        this.messageContainer.removeAttribute('hidden');
        this.messageElement.querySelector('.message-closebutton').addEventListener('click', (e) => this.close());
    }

    /**
     * Open element
     * @return Element the message element that was added
     */
    open() {
        let wrapper = document.createElement('div');

        this.messageElement = this.template.content.cloneNode(true);

        wrapper.appendChild(this.messageElement);
        wrapper.innerHTML = wrapper.innerHTML.replace('{{message}}', this.message);
        wrapper.innerHTML = wrapper.innerHTML.replace(new RegExp('{{type}}', 'g'), this.type);

        this.messageContainer.insertAdjacentHTML('afterbegin', wrapper.innerHTML);

        this.messageElement = this.messageContainer.firstElementChild;

        if (!Message.inViewport(this.messageContainer)) {
            this.messageElement.scrollIntoView({behavior: 'smooth'});
        }
    }

    /**
     * Close
     */
    close() {
        this.messageContainer.removeChild(this.messageElement);

        if (!this.messageContainer.children.length) {
            this.messageContainer.setAttribute('hidden', true);
        }
    }


    /**
     * In viewport
     * Utility method
     * @param {Element} element
     * @return Boolean
     */
    static inViewport(element) {
        let rectangularData = element.getBoundingClientRect();
        return rectangularData.bottom > 0 &&
            rectangularData.right > 0 &&
            rectangularData.left < window.innerWidth &&
            rectangularData.top < window.innerHeight;
    }
}
